import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ModalController} from '@ionic/angular/lazy';

@Component({
  standalone: false,
  selector: 'app-qr-code-component',
  templateUrl: './qr-code-component.component.html',
  styleUrls: ['./qr-code-component.component.scss'],
})
export class QrCodeComponentComponent implements OnInit {

  // Data passed in by componentProps
  @Input() asNumber: string;
  @Input() svg: string;

  svgSave:SafeHtml;
  code: string;

  constructor(private sanitizer: DomSanitizer, private modal: ModalController) { }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  ngOnInit() {
    this.svgSave = this.sanitizer.bypassSecurityTrustHtml(this.svg);
    this.code = this.asNumber;
  }

}
